import { PaymentValidationFeaturePage } from "../ui";

/**
 * PaymentValidationPage 页面组件（由脚手架生成）。
 *
 * 权限软提示：
 * - 先阅读 docs/conventions/authz-design.md，确认功能事实归属与数据权限边界。
 * - 在 shared/authz/permission-registry.json 注册页面和动作权限。
 * - 菜单与路由使用 PermissionRoute，页面内按钮使用 PermissionGate 或统一 ability 判断。
 * - 通用功能权限 AND 业务数据权限；CRM 数据身份不得写入通用权限。
 * - 路由进入即触发 POST/PUT/PATCH/DELETE 时使用对应动作权限，不能只用 :access。
 * - 本提示不作为硬门禁；已填写的权限码必须能在注册表中找到。
 */
export function PaymentValidationPage() {
  return <PaymentValidationFeaturePage />;
}
